import { buildApiConfig, customerApi } from '~/data/api';

import { AuthUser, Role } from '../../types';
import SUPPORT_EMAILS from './supportEmails';

const ROLES_LIST: Role[] = ['consumer', 'producer', 'support'];

const hasSupportAccess = (email: string) => SUPPORT_EMAILS.includes(email);

export const buildRoles = async (user: Omit<AuthUser, 'roles'>, token: string): Promise<Role[]> => {
  const api = customerApi(async () => buildApiConfig(token));
  const customerData = await api.getCustomerType();

  const customerRole = (customerData?.profileType || '').toLowerCase() as Role;

  const roles: Role[] = [];

  if (ROLES_LIST.includes(customerRole)) {
    roles.push(customerRole);
  }

  if (hasSupportAccess(user.email as string)) {
    roles.push('support');
  }

  return roles;
};
